<div class="pagination" *ngIf="total > 0">
    <span>{{ getMin() }} of {{ getMax() }} of {{ count }}</span>
    <span>{{ totalPages() }} pages</span>
    <button (click)="onPrev()" [disabled]="page === 1 || loading">Previous</button>
    <button *ngFor="let pageNum of getPages()" (click)="onPage(pageNum)"></button>
    <button (click)="onNext()" [disabled]="lastPage() || loading">Next</button>
</div>